module.exports = __webpack_public_path__ + "img/four-swords-adventure.c1b1db06.jpg";